import { useCallback, useContext, useState } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useClusterHealth = () => {
  const { sendRequest, isLoading } = useHttp();
  const { getAuthHeaders } = useContext(AuthContext);
  const [clusterStatus, setClusterStatus] = useState(null);
  const [leaderLog, setLeaderLog] = useState([]);
  const [cronStatus, setCronStatus] = useState([]);

  const fetchClusterStatus = useCallback(async () => {
    const response = await sendRequest({
      url: '/api/v1/cluster-health',
      headers: getAuthHeaders(),
    });
    if (response) {
      setClusterStatus(response);
    }
    return response;
  }, [sendRequest, getAuthHeaders]);

  const fetchLeaderLog = useCallback(
    async (count = 50) => {
      const response = await sendRequest({
        url: '/api/v1/cluster-health/leader-log',
        headers: getAuthHeaders(),
        params: { count },
      });
      if (response && response.log) {
        setLeaderLog(response.log);
      }
      return response;
    },
    [sendRequest, getAuthHeaders]
  );

  const fetchCronStatus = useCallback(async () => {
    const response = await sendRequest({
      url: '/api/v1/cluster-health/cron-status',
      headers: getAuthHeaders(),
    });
    if (response && response.items) {
      setCronStatus(response.items);
    }
    return response;
  }, [sendRequest, getAuthHeaders]);

  // Cluster-wide reset of the per-(command, collection) Mongo aggregates.
  // Backend broadcasts the reset via Redis pub/sub, so a single HTTP POST
  // clears every instance — no more HTTP keep-alive sticky-connection issues
  // (which would have meant only the LB-picked instance gets reset).
  const resetMongoStats = useCallback(async () => {
    return sendRequest({
      url: '/api/v1/cluster-health/mongo-stats/reset',
      method: 'POST',
      headers: getAuthHeaders(),
    });
  }, [sendRequest, getAuthHeaders]);

  return {
    clusterStatus,
    leaderLog,
    cronStatus,
    isLoading,
    fetchClusterStatus,
    fetchLeaderLog,
    fetchCronStatus,
    resetMongoStats,
  };
};

export default useClusterHealth;
